export const idp = {
  CODECOSMOS: 'CODECOSMOS',
  CODEFEVER: 'CODEFEVER',
  FTRPRF: 'FTRPRF',
};

export const ftrprfLegible = 'Future Proof';
